<template>
  <article>
    <hero :page="page" v-if="hasHero"></hero>
    <section class="postContent" :style="{ background: 'transparent', width: '100%' }">
      <div class="container">
        <div class="fullWidth" v-if="!page.policy_id">
          <h1 class="pageTitle" v-html="page.title" v-if="!hasHero"></h1>
          <div v-html="pageContent"></div>
        </div>
        <div class="fullWidth" v-if="page.policy_id">
          <div id="policy-embed" v-if="policy" v-html="policy"></div>
          <div v-else>
            <p>
              Please wait while the policy is loaded. If it does not load, please <a :href="`https://app.termageddon.com/api/policy/${page.policy_id}?h-align=left&no-title=true&table-style=accordion`" target="_blank" rel="nofollow noopener">click here</a>.
            </p>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
import axios from 'axios'
import Hero from '@/components/common/Hero'

export default {
  name: 'page',
  props: ['page'],
  components: {
    Hero
  },
  data () {
    return {
      policy: ''
    }
  },
  methods: {
    getPolicy () {
      axios.get(`https://app.termageddon.com/api/policy/${this.page.policy_id}`)
        .then((response) => {
          this.policy = response.data
        })
    }
  },
  mounted () {
    if (this.page.policy_id) {
      this.getPolicy()
    }
  },
  computed: {
    hasHero () {
      return this.page.hero.title && this.page.hero.lead
    },
    pageContent () {
      let vm = this
      if (vm.page && vm.page.content) {
        let content = vm.page.content
        if (process.env.NODE_ENV === 'development') {
          content = content.split('src="http://longestshortesttime').join('src="http://cdn.longestshortesttime')
        }
        return content
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Page.vue?2a5064fc